function toNumber(value: any): any {
    if (value == null) {
        return value;
    }

    if (Array.isArray(value)) {
        return value.map((v): any => (v == null ? v : Number(v)));
    }

    return Number(value);
}

// ----------------------------------------------------------------------------

export default toNumber;
